import ArrowDown from './svg/arrow-down';
import ArrowUp from './svg/arrow-up';
import EasyPost from './svg/easy-post';
import Fingerprint from './svg/fingerprint';
import Help from './svg/help';
import Itsme from './svg/itsme';
import ManageGates from './svg/manage-gates';
import MiniQr from './svg/mini-qr';
import My from './svg/my';
import Package from './svg/package';
import Plus from './svg/plus';
import Printer from './svg/printer';
import Recycle from './svg/recycle';
import Scanner from './svg/scanner';
import Search from './svg/search';
import Settings from './svg/settings';
import Shirt from './svg/shirt';
import ShoppingBasket from './svg/shopping-basket';
import Stock from './svg/stock';
import Undo from './svg/undo';
import Utilities from './svg/utilities';

export function getIconByValue(value: string): (props: { className?: string }) => React.JSX.Element {
    const icon = ALL_ICONS.find((icon) => icon.value === value);
    if (icon && icon.display) {
        return icon.display;
    }
    return My;
}
export type IconType = 'icon' | 'subicon';

export const ALL_ICONS: {
    label: string;
    value: string;
    type: IconType;
    display: (props: { className?: string }) => React.JSX.Element;
}[] = [
    // Icons
    {
        label: 'Utilities',
        value: 'utilities',
        display: Utilities,
        type: 'icon'
    },
    {
        label: 'Fingerprint',
        value: 'auth',
        display: Fingerprint,
        type: 'icon'
    },
    {
        label: 'Help',
        value: 'help',
        display: Help,
        type: 'icon'
    },
    {
        label: 'My',
        value: 'my',
        display: My,
        type: 'icon'
    },
    {
        label: 'Package',
        value: 'package',
        display: Package,
        type: 'icon'
    },
    {
        label: 'Plus',
        value: 'plus',
        display: Plus,
        type: 'icon'
    },
    {
        label: 'Printer',
        value: 'printer',
        display: Printer,
        type: 'icon'
    },
    {
        label: 'Recycle',
        value: 'recycle',
        display: Recycle,
        type: 'icon'
    },
    {
        label: 'Scanner',
        value: 'scanner',
        display: Scanner,
        type: 'icon'
    },
    {
        label: 'Search',
        value: 'search',
        display: Search,
        type: 'icon'
    },
    {
        label: 'Settings',
        value: 'settings',
        display: Settings,
        type: 'icon'
    },
    {
        label: 'Shirt',
        value: 'shirt',
        display: Shirt,
        type: 'icon'
    },
    {
        label: 'Shopping Basket',
        value: 'shopping-basket',
        display: ShoppingBasket,
        type: 'icon'
    },
    {
        label: 'Stock',
        value: 'stock',
        display: Stock,
        type: 'icon'
    },
    {
        label: 'Undo',
        value: 'undo',
        display: Undo,
        type: 'icon'
    },
    {
        label: 'Manage gates',
        value: 'manage-gates',
        display: ManageGates,
        type: 'icon'
    },

    // Special icons
    {
        label: 'itsme',
        value: 'itsme',
        display: Itsme,
        type: 'icon'
    },
    {
        label: 'EasyPost',
        value: 'easy-post',
        display: EasyPost,
        type: 'icon'
    },

    // Subicons
    {
        label: 'Arrow Down',
        value: 'arrow-down',
        display: ArrowDown,
        type: 'subicon'
    },
    {
        label: 'Arrow Up',
        value: 'arrow-up',
        display: ArrowUp,
        type: 'subicon'
    },
    {
        label: 'Plus',
        value: 'plus',
        display: Plus,
        type: 'subicon'
    },
    {
        label: 'QR Code',
        value: 'qr-code',
        display: MiniQr,
        type: 'subicon'
    },
    {
        label: 'Search',
        value: 'search',
        display: Search,
        type: 'subicon'
    }
];
